import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

let toastTimeout = ''

export default new Vuex.Store({
  state: {
    pageLoading: true, //加载动画
    dialogData: null, //弹框数据
    userinfo: null,  // 用户信息
    openDownLoadFlag: false, //引流弹框
    toastData: null,
  },
  mutations: {
    setPageLoading(state, flag) {
      state.pageLoading = flag
    },
    setDialogData(state, data) {
      state.dialogData = data
    },
    setOpenDownLoadFlag (state, flag) {
      state.openDownLoadFlag = flag
    },
    setToastData (state, data) {
      clearTimeout(toastTimeout)
      state.toastData = data
      toastTimeout = setTimeout(() => {
        clearTimeout(toastTimeout)
        state.toastData = null
      }, 1500);
    }
  },
  actions: {
    setPageLoadingAsync({ commit, state }, flag) {
      commit('setPageLoading', flag)
    },
    setDialogDataAsync({ commit, state }, data) {
      commit('setDialogData', data)
    },
    setUserinfo({ state }, data) {
        sessionStorage.setItem('COVER_USERINFO', JSON.stringify(data));
      state.userinfo = data;
    },
  }
})
